import { PropsWithChildren, ReactElement } from "react";
import { Provider } from "react-redux";
import { store } from "../redux/store";
import AuthProvider from "./auth/AuthProvider";
import ThemeProviders from "./theme/ThemeProviders";

export default function Providers({ children }: PropsWithChildren): ReactElement {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProviders>
          {children}
        </ThemeProviders>
      </AuthProvider>
    </Provider>
  );
}
